import {mapActions} from "vuex";

export default {
    methods: {
        async goToRoom(recipientId, messageType, messageTypeId, showShippingAddressConfirmation){
            let payload = {
                senderId: this.$auth.user().id,
                recipientId: recipientId,
                messageType: messageType, 
                messageTypeId: messageTypeId,
            }
            await axios.post('rooms', payload)
            .then((res)=> {
                if(!res.data.alreadyExist){
                    this.newMessage({
                        template_id: 13,
                        params: [],
                        order_id: null,
                        recipient: recipientId,
                        sender: this.$auth.user().id,
                        type: res.data.data.type,
                        type_id: res.data.data.type_id,
                        checked:1,
                        index:0,
                        room_id: res.data.data.id,
                    }).then(()=>{
                        this.$nextTick(() => {
                            this.$router.push({ name: 'Inbox', query: { roomId: res.data.data.id, shippingAddressValidated: showShippingAddressConfirmation } });
                        });
                    })
                }else{
                    this.$router.push({ name: 'Inbox', query: { roomId: res.data.data.id, shippingAddressValidated: showShippingAddressConfirmation } });
                }
            }).catch(function(error) {
                console.log(error)
            });
        },
        ...mapActions('messages', ['newMessage']),
    }
}
